var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-2.523 2.505a12.77 12.77 0 0 0-4.57 1.89A2.035 2.035 0 0 0 4 18.09V20h16v-1.91c0-.681-.34-1.317-.906-1.694a12.769 12.769 0 0 0-4.57-1.891 12.916 12.916 0 0 0-5.047 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionUser);
export default __webpack_public_path__ + "static/media/ic_action_user.736e0ad3cac4af0a1e6751f29e437659.svg";
export { ForwardRef as ReactComponent };